import { useSuspenseQuery } from '@tanstack/react-query'
import { BarcodeExtractionApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { isHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { barcodeSettingQueryKeys } from './queryKeys'

export const useQueryBarcodeExtractionRule = () => {
  return useSuspenseQuery({
    queryKey: barcodeSettingQueryKeys.rule,
    queryFn: async () => {
      try {
        return await baseClient
          .getApi(BarcodeExtractionApi)
          .getBarcodeExtractionRule()
      } catch (error) {
        // 未設定の場合は 404 が返る。エラーにせず null を返す
        // TanStack Query v5 は undefined を queryFn の戻り値として禁止しているため null を使用する
        if (error instanceof Response) {
          const body = await error.json()
          if (isHTTPError(body) && body.status === 404) return null
          throw body
        }
        throw error
      }
    },
    retry: 0,
    gcTime: 0,
  })
}
